/**
 * Copyright (C) 2023 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import appTheme from '../../../common/theme/appTheme.json';
const useStyles = makeStyles(() =>
  createStyles({
    linkDiv: {
      color: appTheme.externalLinkColor,
      cursor: 'pointer',
    },
  }),
);
export interface MenuButtonProps {
  onClick(): void;
}
const MenuButton: React.FunctionComponent<MenuButtonProps> = props => {
  const classes = useStyles();
  return (
    <div className={classes.linkDiv} onClick={props.onClick}>
      {props.children}
    </div>
  );
};
export default MenuButton;
